import { save, store } from './store';

let running = false;
let last = 0;
let raf = 0;
let saveAccumulator = 0;

const MAX_DT = 0.5;
const SAVE_INTERVAL = 5;

function loop(now: number): void {
  if (!running) return;
  if (last === 0) last = now;
  let dt = (now - last) / 1000;
  last = now;
  if (dt > MAX_DT) dt = MAX_DT;
  store.getState().tick(dt);
  saveAccumulator += dt;
  if (saveAccumulator >= SAVE_INTERVAL) {
    saveAccumulator = 0;
    save();
  }
  raf = requestAnimationFrame(loop);
}

export function startTick(): void {
  if (running) return;
  running = true;
  last = 0;
  raf = requestAnimationFrame(loop);
}

export function stopTick(): void {
  running = false;
  if (raf) cancelAnimationFrame(raf);
  save();
}

window.addEventListener('beforeunload', () => save());
document.addEventListener('visibilitychange', () => {
  if (document.hidden) save();
});
